export default function randomString(length: number = 10) {
	return Math.random()
		.toString(36)
		.toUpperCase()
		.substr(2, 2 + length)
}
